import {objectPropertiesToArray} from "../utils/utils";
import {FunctionComponent} from "react";
import {ComponentTypeMappings} from "./component-mappings";

interface IComponentType extends Object {
    name: String,
    dashboardComponent: boolean,
    supportsStatusCallback?: boolean,
    invisible?: boolean,
    entryPoint: Function,
    editorEntryPoint?: FunctionComponent<ICommonComponentEditorProps>,
    editorConfig?: EditorConfig
}


export type ComponentTypeWithID = IComponentType & IdType

type EditorConfig = {
    hasTitle: boolean
}

export interface ICommonComponentEditorProps {
    config: any,
    onConfigChange: (newConfig: any) => void
}

export interface IComponentTypeMapping {
    [key: string]: IComponentType
}

export function loadComponentModule(type: keyof IComponentTypeMapping) {
    if (!(type in ComponentTypeMappings)) {
        console.warn("Can't map unknown component type: " + type)
        return undefined;
    }

    return ComponentTypeMappings[type].entryPoint()
}

export function getComponentType(type: keyof IComponentTypeMapping): IComponentType | undefined {
    if (!(type in ComponentTypeMappings)) {
        return undefined;
    }

    return ComponentTypeMappings[type]
}

export function getDashboardComponentTypes(): ComponentTypeWithID[] {
    return objectPropertiesToArray(ComponentTypeMappings).filter((type) => type.dashboardComponent == true) as ComponentTypeWithID[];
}
